"use strict";

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { _defineProperty(target, key, source[key]); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

/**
 * JS-son environment generator
 * @param {array} agents JS-son agents to run
 * @param {object} state Initial environment state
 * @param {function} update Update function, in particular for processing agent actions
 * @param {function} render Visualization function of the environment's current state
 * @param {function} stateFilter Function for filtering state that agents should receive
 * @returns {object} JS-son environment object
*/
function Environment(agents, state, update) {
  var _this = this;

  var render = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : function (state) {
    return console.log(state);
  };
  var stateFilter = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : function (state) {
    return state;
  };
  this.agents = {};
  agents.forEach(function (agent) {
    return _this.agents[agent.id] = agent;
  });
  this.state = state;
  this.update = update;
  this.render = render;
  this.stateFilter = stateFilter;
  this.history = [];

  this.reset = function () {
    return _this.history = [];
  };

  this.run = function (iterations) {
    _this.history.push(_this.state);

    var run = function run() {
      Object.keys(_this.agents).forEach(function (agentKey) {
        var proposedUpdate = _this.agents[agentKey].next(_this.stateFilter(_this.state, agentKey, _this.agents[agentKey].beliefs));

        var stateUpdate = _this.update(proposedUpdate, agentKey, _this.state);

        _this.state = _objectSpread({}, _this.state, stateUpdate);
      });

      _this.history.push(_this.state);

      _this.render(_this.state);
    };

    if (iterations) {
      Array(iterations).fill(0).forEach(run);
    } else {
      while (true) {
        run();
      }
    }

    return _this.history;
  };
}

module.exports = Environment;